<template>
  <div>
    <div id="terminal-container"></div>
  </div>
</template>

<script>
import 'xterm/dist/xterm.css'
import 'xterm/dist/addons/fullscreen/fullscreen.css' // 全屏
import * as fit from 'xterm/lib/addons/fit/fit' // 自适应宽度
import { Terminal } from 'xterm'

export default {
  name: 'console',
  data () {
    return {
      copy: ''
    }
  },
  mounted () {
    let terminalContainer = document.getElementById('terminal-container')
    // let term = new Terminal()
    let term = new Terminal({
      cols: 92,
      rows: 22,
      cursorBlink: true, // 光标闪烁
      cursorStyle: 'block', // 光标样式  null | 'block' | 'underline' | 'bar'
      scrollback: 800, // 回滚
      tabStopWidth: 8, // 制表宽度
      screenKeys: true
    })
    term.on('key', function (key, ev) {
      if (ev.keyCode === 13) {
        term.writeln(key)
      } else {
        term.write(key)
      }
    })
    term.open(terminalContainer, true)
    // 自适应宽度
    Terminal.applyAddon(fit)
    term.fit()
    // 全屏
    Terminal.applyAddon(fullscreen)
    term.toggleFullScreen()
    // 选中 复制
    term.on('selection', function () {
      if (term.hasSelection()) {
        this.copy = term.getSelection()
      }
    })
    // 粘贴 ctrl+v
    term.attachCustomKeyEventHandler(function (ev) {
      if (ev.keyCode === 86 && ev.ctrlKey) {
        // websocket.send(new TextEncoder().encode("\x00" + this.copy))
      }
    })
    window.onresize = function () {
      term.fit()
      term.scrollToBottom()
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
